if (!customElements.get('kylin-specifications')) {
  customElements.define('kylin-specifications', class extends HTMLElement {
    connectedCallback() {
      this.productInfo = this.closest('product-info');
      // Dawn changes the hidden variant input before publishing its server-rendered variant data.
      // Hide stale dimensions even when the newly selected combination is unavailable.
      this.onVariantInput = (event) => {
        if (event.target.name === 'id') this.querySelector('[data-variant-dimensions]').hidden = true;
      };
      this.productInfo?.addEventListener('change', this.onVariantInput);
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (String(data.sectionId) !== this.dataset.section) return;
        const source = Array.from(data.html.querySelectorAll('kylin-specifications'))
          .find((element) => element.dataset.section === this.dataset.section)
          ?.querySelector('[data-variant-dimensions]');
        const target = this.querySelector('[data-variant-dimensions]');
        if (!source || !target) return;
        target.replaceChildren(...Array.from(source.childNodes, (node) => node.cloneNode(true)));
        target.hidden = source.hidden;
      });
    }

    disconnectedCallback() {
      this.unsubscribe?.();
      this.productInfo?.removeEventListener('change', this.onVariantInput);
    }
  });
}
